import { Authorizer } from "casbin.js";

export function createAuthorizer(
  mode = "auto",
  endpoint = "/api/user/permissions"
) {
  return new Authorizer(mode, {
    endpoint: endpoint,
    cacheExpiredTime: 0,
  });
}
